import { NgModule } from '@angular/core'
import { RouterModule, Routes } from '@angular/router'
import { MainComponent } from './pages/main/main.component'

const routes: Routes = [
  {
    path: '',
    component: MainComponent
  },
  {
    path: ':teamId/:territoryId',
    component: MainComponent
  }
]

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class GameLayoutRoutingModule { }
